import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Radio from '@mui/material/Radio';
import { useTranslation } from 'react-i18next';

type Props = {
  shipmentId?: number;
  allChecks?: boolean;
  onlyUser?: boolean;
  onlyWarehouse?: boolean;
  superVisor?: boolean;
  disableWhileLoadingData?: boolean;
};

function ValidateType({
  shipmentId,
  allChecks,
  onlyUser,
  onlyWarehouse,
  superVisor,
  disableWhileLoadingData
}: Props) {
  const { t } = useTranslation('global');
  if (allChecks) {
    return (
      <Stack marginX="auto">
        <FormControlLabel
          control={<Radio />}
          data-testid="radio-warehouse-warehouse"
          disabled={!!shipmentId || disableWhileLoadingData}
          label={t('shipment.newShipment.warehouse2Warehouse')}
          value="1"
        />
        <FormControlLabel
          control={<Radio />}
          disabled={!!shipmentId || disableWhileLoadingData}
          label={t('shipment.newShipment.warehouse2TaskForce')}
          value="2"
        />
        <FormControlLabel
          control={<Radio />}
          disabled={!!shipmentId || disableWhileLoadingData}
          label={t('shipment.newShipment.taskForce2TaskForce')}
          value="3"
        />
        <FormControlLabel
          control={<Radio />}
          disabled={!!shipmentId || disableWhileLoadingData}
          label={t('shipment.newShipment.taskForce2Warehouse')}
          value="4"
        />
      </Stack>
    );
  }
  if (onlyUser || superVisor) {
    return (
      <Stack marginX="auto">
        <FormControlLabel
          control={<Radio />}
          disabled={!!shipmentId || disableWhileLoadingData}
          label={t('shipment.newShipment.taskForce2TaskForce')}
          value="3"
        />
        <FormControlLabel
          control={<Radio />}
          disabled={!!shipmentId || disableWhileLoadingData}
          label={t('shipment.newShipment.taskForce2Warehouse')}
          value="4"
        />
      </Stack>
    );
  }
  if (onlyWarehouse) {
    return (
      <Stack marginX="auto">
        <FormControlLabel
          control={<Radio />}
          disabled={!!shipmentId || disableWhileLoadingData}
          label={t('shipment.newShipment.warehouse2Warehouse')}
          value="1"
        />
        <FormControlLabel
          control={<Radio />}
          disabled={!!shipmentId || disableWhileLoadingData}
          label={t('shipment.newShipment.warehouse2TaskForce')}
          value="2"
        />
      </Stack>
    );
  }
  return null;
}

export default ValidateType;
